<div class="row">
    <div class="col-sm-12">
        <div class="container form-container">
            <form [formGroup]="formChangePassword" class="card-body needs-validation">

                <div class="form-group">
                    <label for="">Ingrese la contraseña actual:</label>  
                    <br/>
                    <br/>
                    <div class="input-group mb-3 no-wrap">
                    <input
                        [type]="showCurrentPassword ? 'text' : 'password'"
                        id="currentPassword"
                        class="form-control custom-password"
                        formControlName="currentPassword"
                        >

                    <button type="button"
                            class="btn btn-outline-secondary"
                            (click)="showCurrentPassword = !showCurrentPassword"
                            aria-label="Mostrar/Ocultar">
                        <i class="fa" [ngClass]="showCurrentPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                    </button>
                    </div>
                </div>


                <div class="form-group">
                    <label for="">Ingrese su nueva contraseña:</label>
                    <br/>
                    <br/>                      
                    <div class="input-group mb-3 no-wrap">
                        <input
                            [type]="showNewPassword ? 'text' : 'password'"
                            id="newPassword"
                            class="form-control custom-password"
                            formControlName="newPassword"
                            >
                                <button type="button"
                                    class="btn btn-outline-secondary"
                                    (click)="showNewPassword = !showNewPassword"
                                    aria-label="Mostrar/Ocultar"
                                        
                                >
                                    <i class="fa" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                                </button>
                    </div>
                    <app-password-requirements
                        [passwordControl]="formChangePassword.get('newPassword')"
                        [confirmControl]="formChangePassword.get('repeatPassword')"
                        >
                    </app-password-requirements>
                </div>

                <div class="form-group">
                    <label for="">Repita su nueva contraseña:</label>                            
                    <br/>
                    <br/>
                    <div class="input-group mb-3 no-wrap">
                        <input
                            [type]="showRepeatNewPassword ? 'text' : 'password'"
                            id="repeatPassword"
                            class="form-control custom-password"
                            formControlName="repeatPassword"
                        />

                        <button type="button"
                                class="btn btn-outline-secondary"
                                (click)="showRepeatNewPassword = !showRepeatNewPassword"
                                aria-label="Mostrar/Ocultar">
                            <i class="fa" [ngClass]="showRepeatNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                        </button>
                    </div>
                    
                </div>


                <div class="row">
                    <div class="col-md-3"></div>
                    <div class="col-md-3"></div>
                    <div class="col-md-3"></div>
                    <div class="col-md-3 col-sm-12">
                        <button 
                            class="btn btn-primary w-100"
                            (click)="changePassword()"
                            [disabled]="!formChangePassword.valid"
                        >
                            <i class="fa fa-save"></i>
                        </button>
                    </div>
                </div>

            </form>
        </div>                       
    </div>
    </div>